// Per-lane slot lists (`no||yes`), told apart by key, not by value:
// `source_identifier:internal = ttom-sd|2024.03.007` holds a `|` and is no slot list.
import { baseKey } from "./lrValues.mjs";

const COUNT_KEYS = new Set([
  "lanes",
  "lanes:forward",
  "lanes:backward",
  "lanes:both_ways",
  "lanes:reversible",
]);

/** @param {string} key a key without its layer prefix */
export function isLaneCountKey(key) {
  return COUNT_KEYS.has(baseKey(key));
}

/** @param {string} key a key without its layer prefix */
export function isSlotKey(key) {
  const base = baseKey(key);
  if (base.startsWith("feedback:") || base.startsWith("meta:")) return false;
  return !COUNT_KEYS.has(base) && base.split(":").includes("lanes");
}

/**
 * @param {string} value
 * @returns {string[]} one entry per slot, blanks kept
 */
export function splitSlots(value) {
  return String(value)
    .split("|")
    .map((slot) => slot.trim());
}
